import { ref } from 'vue';

export const nodeActionSignal = ref({
  action: null,
  nodeId: null,
  ts: 0,
  data: null,
});

export function triggerNodeAction(action, nodeId, data = null) {
  nodeActionSignal.value = { action, nodeId, ts: Date.now(), data };
}
